export enum AthleteAuthorizationFlow {
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  VERIFY_EMAIL_ALREADY_EXISTS = 'VERIFY_EMAIL_ALREADY_EXISTS',
  LOGIN = 'LOGIN',
}
